import { createFileRoute } from '@tanstack/react-router'
import { AppointmentReschedule } from '@/components/appointment/AppointmentReschedule.tsx'
import { AppointmentSectionOne } from '@/components/appointment/AppointmentSectionOne'
import { getAppointment } from '@/components/appointment/serverFn.ts'

export const Route = createFileRoute('/appointment/reschedule/$id/')({
	loader: async ({ params }) => await getAppointment({ data: { id: params.id } }),
	component: RouteComponent,
})

function RouteComponent() {
	const { appointment, holidays } = Route.useLoaderData()
	return (
		<>
			<AppointmentSectionOne reschedule />
			<AppointmentReschedule appointment={appointment} holidays={holidays} />
		</>
	)
}
